import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Chart } from "chart.js";
import * as _ from "lodash";
import * as moment from "moment";
import { ThemeService } from "ng2-charts";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { Helper } from "src/app/shared/helpers/helper";
import { QueryParams } from "src/app/shared/models/query-params";
import { DashboardService } from "./dashboard.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [ThemeService],
})
export class DashboardComponent implements OnInit {
  goback = "";
  subscription = new Subscription();

  form: FormGroup;
  startDate = new FormControl();
  minStartDate = new Date();
  strStartDate = "";
  endDate = new FormControl();
  minEndDate = null;
  strEndDate = "";
  public osPorTipoChart: any;
  public osAbertaFechadaChart: any;
  public osPorTipoPizzaChart: any;

  monthMapping = {
    "01": "Janeiro",
    "02": "Fevereiro",
    "03": "Março",
    "04": "Abril",
    "05": "Maio",
    "06": "Junho",
    "07": "Julho",
    "08": "Agosto",
    "09": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
  };

  constructor(
    private dashboardService: DashboardService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {}

  async ngOnInit() {
    this.form = new FormGroup({
      startDate: new FormControl("" as string),
      endDate: new FormControl("" as string),
    });
    this.createOSPorTipoChart();
    this.createOSAbertaFechadaChart();
    this.createOSPorTipoPizzaChart();
    this.realoadCharts();
  }

  createOSAbertaFechadaChart() {
    const canvas = document.getElementById(
      "OSAbertaFechadaChart"
    ) as HTMLCanvasElement | null;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        this.osAbertaFechadaChart = new Chart(ctx, {
          type: "bar", // ou 'line' para gráfico de linhas
          data: {
            labels: [], // Meses
            datasets: [
              {
                label: "OS Aberta",
                data: [],
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                borderColor: "rgba(255, 99, 132, 1)",
                borderWidth: 1,
              },
              {
                label: "OS Fechada",
                data: [],
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 1,
              },
            ],
          },
          options: {
            responsive: true,
          },
        });
      }
    }
  }

  createOSPorTipoChart() {
    this.osPorTipoChart = new Chart("OSPorTipoChart", {
      type: "bar", // ou 'line' para gráfico de linhas
      data: {
        labels: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
        ], // Meses
        datasets: [
          {
            label: "Tipo A",
            data: [10, 20, 30, 40, 50, 60, 70], // Dados fictícios para Tipo A
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 1,
          },
          {
            label: "Tipo B",
            data: [15, 25, 35, 45, 55, 65, 75], // Dados fictícios para Tipo B
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
          {
            label: "Tipo C",
            data: [5, 10, 15, 20, 25, 30, 35], // Dados fictícios para Tipo C
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        /*  scales: {
          y: {
            beginAtZero: true,
          },
        }, */
      },
    });
  }

  createOSPorTipoPizzaChart() {
    this.osPorTipoPizzaChart = new Chart("OSPorTipoPizzaChart", {
      type: "pie", // Gráfico de pizza
      data: {
        labels: ["Tipo A", "Tipo B", "Tipo C"], // Tipos de OS
        datasets: [
          {
            label: "Total de OS",
            data: [40, 30, 20], // Dados fictícios
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(75, 192, 192, 0.2)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(75, 192, 192, 1)",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
      },
    });
  }

  realoadCharts() {
    try {
      this.reloadOSAbertaFechadaChart();
    } catch (err) {
      this.spinner.hide();
    }
  }

  reloadOSAbertaFechadaChart() {
    const canvas = document.getElementById(
      "OSAbertaFechadaChart"
    ) as HTMLCanvasElement | null;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        this.spinner.show();
        this.subscription.add(
          this.dashboardService
            .openCloseSchedule(this.getQueryParams())
            .subscribe(
              (res) => {
                console.log(res);
                const labels = res.data.map(
                  (item) =>
                    `${
                      this.monthMapping[item.mes.substring(4, 6)]
                    }/${item.mes.substring(0, 4)}`
                );
                const opened = res.data.map((item) => parseInt(item.abertos));
                const closed = res.data.map((item) => parseInt(item.fechados));
                // Update the chart's data
                this.osAbertaFechadaChart.data.labels = labels;
                this.osAbertaFechadaChart.data.datasets[0].data = opened;
                this.osAbertaFechadaChart.data.datasets[1].data = closed;

                // Call update() to re-render the chart
                this.osAbertaFechadaChart.update();
                this.spinner.hide();
              },
              (err) => {
                this.spinner.hide();
              }
            )
        );
      }
    }
  }

  onChangeStartDate(event) {
    this.strStartDate = Helper.getFormattedBrDate(event.value);
    this.endDate = new FormControl();
    this.minEndDate = new Date(event.value);
    this.strEndDate = "";
    this.form.controls.endDate.setValue("");
    this.form.controls.endDate.updateValueAndValidity();
  }

  onChangeEndDate(event) {
    this.strEndDate = Helper.getFormattedBrDate(event.value);
  }

  clearPeriod() {
    this.strStartDate = "";
    this.form.controls.startDate.setValue("");
    this.form.controls.startDate.updateValueAndValidity();

    this.strEndDate = "";
    this.form.controls.endDate.setValue("");
    this.form.controls.endDate.updateValueAndValidity();
  }

  async onSubmit() {
    if (this.validateForm()) {
      this.realoadCharts();
    } else {
      Alert.warning(Alert.getMessage().errors.requiredFilters);
    }
  }

  getQueryParams() {
    const params: QueryParams[] = [];
    const filters = this.form.controls;

    if (!_.isNull(filters.startDate.value) && filters.startDate.value !== "") {
      params.push({
        id: "startDate",
        value: moment(filters.startDate.value).format("YYYY-MM-DD"),
      });
    }

    if (!_.isNull(filters.endDate.value) && filters.endDate.value !== "") {
      params.push({
        id: "endDate",
        value: moment(filters.endDate.value).format("YYYY-MM-DD"),
      });
    }

    return this.prepareQueryParams(params);
  }

  prepareQueryParams(params: QueryParams[]) {
    let queryParams = "";
    params.map((param) => {
      queryParams = queryParams === "" ? "" : `${queryParams}&`;
      queryParams = `${queryParams}${param.id}=${param.value}`;
    });
    return queryParams;
  }

  validateForm() {
    if (
      this.form.controls.startDate.value !== "" ||
      this.form.controls.endDate.value !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }
}
